<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--VIDEO DETAIL PAGE-->
<ng-template [ngIf]="!isLoading">
  <ng-container *ngIf="subVideo">
    <!--VIDEO SECTION CONTAINER-->
    <section class="video-detail">
      <div class="video-hero text-color-white">
        <!--VIDEO WRAPPER-->
        <div class="wrapper padding-top-small padding-bottom-small">
          <div class="sub-hero-wrapper">
            <!--VIDEO CONTENT-->
            <app-video-container
              [title]="subVideo.title"
              [embedUrl]="subVideo.embed_url"
              (sendClick)="sendGoogleAnalytics('videos', 'click', subVideo.slug)">
            </app-video-container>
            <!--END VIDEO CONTENT-->
            <div class="video-content">
              <!--VIDEO TITLE AND DATE-->
              <div class="video-title">
                <h3 class="margin-top-small margin-bottom-x-small">
                  {{ subVideo.title | decodeEntities }}
                </h3>
                <h4 *ngIf="subVideo.date_added">{{ subVideo.date_added }}</h4>
              </div>
              <!--END VIDEO TITLE AND DATE-->

              <!--PREVIOUS AND NEXT VIDEO LINKS-->
              <div class="navigate margin-top-small">
                <a class="cursor" (click)="gotoPreviousVideo()">
                  <i class="icon white x-small arrow-left left-arrow cursor"></i>
                  Prev
                </a>
                <span> | </span>
                <a class="cursor" (click)="gotoNextVideo()">
                  Next<i class="icon white x-small arrow-right right-arrow cursor"></i>
                </a>
              </div>
              <!--END PREVIOUS AND NEXT VIDEO LINKS-->
            </div>
          </div>
        </div>
        <!--END VIDEO WRAPPER-->
      </div>

      <!--CONTENT VIDEO WRAPPER-->
      <div class="wrapper">
        <!--ABOUT VIDEO TITLE-->
        <h3 class="margin-bottom-large bold">About This Video</h3>
        <!--END ABOUT VIDEO TITLE-->

        <!--VIDEO DESCRIPTION-->
        <p class="margin-bottom-large" [innerHTML]="subVideo.description"></p>
        <!--END VIDEO DESCRIPTION-->

        <!--EXTERNAL URL BUTTON-->
        <div class="margin-top-small margin-bottom-small" *ngIf="subVideo.external_url">
          <a
            href="{{ subVideo.external_url }}"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="btn btn-primary">
            {{ subVideo.external_link_cta }}
          </a>
        </div>
        <!--END EXTERNAL URL BUTTON-->

        <!--VIDEO SLIDER-->
        <div class="featured-videos" *ngIf="isFeaturedVideo && featuredVideos.length > 1">
          <h3 class="margin-top-large margin-bottom-small bold">More Featured Videos</h3>
          <div class="margin-top-small margin-bottom-small">
            <app-video-slider [videoArray]="featuredVideos"></app-video-slider>
          </div>
        </div>
        <!--END VIDEO SLIDER-->
      </div>
      <!--END VIDEO WRAPPER-->
    </section>
    <!--END VIDEO SECTION CONTAINER-->
  </ng-container>
</ng-template>
<!--END VIDEO DETAIL PAGE-->
